import LoadingType from "../../Models/LoadingType";

export const LOADING_AUTH = "loadingAuth";
export const LOADING_FORGOT_PASSWORD = "loadingForgotPassword";
export const LOADING_RECOVER_PASSWORD = "loadingRecoverPassword";
export const LOADING_PICKUPS = "loadingPickups";
export const LOADING_SAVE_PICKUP = "loadingSavePickup";
export const LOADING_SHIPMENTS = "loadingShipments";
export const LOADING_UNITS = "loadingUnits";
export const LOADING_CONTACTS = "loadingContacts";
export const LOADING_SAVE_CONTACT = "loadingSaveContact";
export const LOADING_ADDRESSES = "loadingAddresses";
export const LOADING_SAVE_ADDRESS = "loadingSaveAddress";
export const LOADING_CITIES = "loadingCities";
export const LOADING_SAVE_CITY = "loadingSaveCity";
export const LOADING_CANCEL_SHIPMENT = "loadingCancelShipment";
export const LOADING_EDIT_SHIPMENT = "loadingEditShipment";
export const LOADING_SHIPMENT_WITH_BILLS = "loadingShipmentWithBills";




export type LType =
  typeof LOADING_AUTH |
  typeof LOADING_FORGOT_PASSWORD |
  typeof LOADING_PICKUPS |
  typeof LOADING_SAVE_PICKUP |
  typeof LOADING_SHIPMENTS |
  typeof LOADING_UNITS |
  typeof LOADING_CONTACTS |
  typeof LOADING_SAVE_CONTACT |
  typeof LOADING_ADDRESSES |
  typeof LOADING_SAVE_ADDRESS |
  typeof LOADING_CITIES |
  typeof LOADING_SAVE_CITY |
  typeof LOADING_CANCEL_SHIPMENT |
  typeof LOADING_EDIT_SHIPMENT |
  typeof LOADING_RECOVER_PASSWORD |
  typeof LOADING_SHIPMENT_WITH_BILLS;

export interface LoadingState {
  loading: LType,
  newStatus: LoadingData
}

export interface LoadingData {
  status: LoadingType,
  message?: string
}

export interface LoadingChangeState {
  loading: LType,
  message?: string
}

export interface LoadingReducerType {
  [LOADING_AUTH]: LoadingData,
  [LOADING_FORGOT_PASSWORD]: LoadingData,
  [LOADING_RECOVER_PASSWORD]: LoadingData,
  [LOADING_PICKUPS]: LoadingData,
  [LOADING_SAVE_PICKUP]: LoadingData,
  [LOADING_SHIPMENTS]: LoadingData,
  [LOADING_UNITS]: LoadingData,
  [LOADING_CONTACTS]: LoadingData,
  [LOADING_SAVE_CONTACT]: LoadingData,
  [LOADING_ADDRESSES]: LoadingData,
  [LOADING_SAVE_ADDRESS]: LoadingData,
  [LOADING_SAVE_CITY]: LoadingData,
  [LOADING_CITIES]: LoadingData,
  [LOADING_CANCEL_SHIPMENT]: LoadingData,
  [LOADING_EDIT_SHIPMENT]: LoadingData,
  [LOADING_SHIPMENT_WITH_BILLS]: LoadingData

}
